import { combineReducers } from 'redux';
import { reducers } from 'examsbook-react-sdk';

//if needed we can put up more reducers here.
export default combineReducers({
    ...reducers
});
